import React from "react";
import { Navigate, useParams } from "react-router-dom";
import useExperiment from "../../../../../api/experiments/useExperiment";
import { appRoutes } from "../../../../../routes/appRoutes";
import { isPublishedExperience } from "../../utils/publishedExperience";

type PublishedExperienceChangeGuardProps = {
  children: React.ReactElement;
};

const PublishedExperienceChangeGuard: React.FC<PublishedExperienceChangeGuardProps> = ({ children }) => {
  const { experimentId, variantId } = useParams();
  const { experiment, isLoading } = useExperiment({ experimentId });

  if (isLoading) return null;

  if (experimentId && variantId && isPublishedExperience(experiment)) {
    return <Navigate to={appRoutes.experiments.variant(experimentId, variantId)} replace />;
  }

  return children;
};

export default PublishedExperienceChangeGuard;
